<div class="modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title h5">{{ 'HEADER.teams_title' | translate }}</h5>
        <button type="button" class="alles" (click)="wisselAlles()">
          {{ (allesAan() ? 'HEADER.clear_all' : 'HEADER.select_all') | translate }}
        </button>
      </div>

      <div class="modal-body">
        @if (teams.length) {
          <ul class="ploegen">
            @for (team of teams; track team) {
              <li>
                <label class="ploeg">
                  <input type="checkbox"
                         class="form-check-input input-primary"
                         [checked]="isGekozen(team)"
                         (change)="wissel(team)">
                  <span class="ploeg-naam">{{ caption(team) }}</span>
                </label>
              </li>
            }
          </ul>
        } @else {
          <p class="leeg">{{ 'HEADER.no_teams' | translate }}</p>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onClose()">
          {{ 'HEADER.done' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
